import React from 'react'
import { useConfirmDialog, useError, useMutation } from '@ztechapps/common.hook'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { deleteProduct_billOfMaterials_with_parent_product } from './graphql'
import type { Product } from '@ztechapps/common.contract'
import { useBillOfMaterialsContext } from './Context'
import { ShowIf } from '@ztechapps/webui.util'

export const Delete = ({ bomId, productId }: { bomId: string; productId: string }) => {
  const [onDelete, , { loading }] = useMutation<{ deleteProduct_billOfMaterials_with_parent_product: Product }>({
    query: deleteProduct_billOfMaterials_with_parent_product,
  })
  const { canEdit, ...context } = useBillOfMaterialsContext()
  const parentProductId = context.product?._id
  const { onError } = useError()

  const { confirm } = useConfirmDialog({
    text: `Are you sure you want to remove this sub-assembly?`,
    title: 'Remove Sub-Assembly.',
    buttons: { confirm: { text: 'Yes, remove it!' } },
  })

  const onClick = async () => {
    await confirm(async () => {
      try {
        await onDelete({
          filter: {
            parentProductId,
            _id: productId,
            'billOfMaterials._id': bomId,
          },
        })
      } catch (e) {
        onError(e)
      }
    })
  }

  return (
    <ShowIf condition={canEdit}>
      <BusyButtonLink
        icon="trash"
        bsStyle="danger"
        className="text-danger"
        bsSize="sm"
        title={`Delete this subcomponent`}
        onClick={onClick}
        isBusy={loading}
        busyText={''}
      />
    </ShowIf>
  )
}
